class User {
	constructor({
		id = '',
		name = '',
		email = '',
		language = '',
		profileColor = '',
		profileImageUrl = '',
		useYn = 0,
		deletedAt = '',
		updatedAt = '',
		updatedBy = '',
		createdAt = '',
		createdBy = '',
		accessToken = '',
		refreshToken = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.email = email === null ? '' : email
		this.language = language === null ? '' : language
		this.profileColor = profileColor === null ? '' : profileColor
		this.profileImageUrl = profileImageUrl === null ? '' : profileImageUrl
		this.useYn = useYn === null || !(useYn === 0 || useYn === 1) ? 0 : useYn
		this.deletedAt = deletedAt === null ? '' : deletedAt
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.createdAt = createdAt === null ? '' : createdAt
		this.createdBy = createdBy === null ? '' : createdBy
		this.accessToken = accessToken === null ? '' : accessToken
		this.refreshToken = refreshToken === null ? '' : refreshToken
	}

	id: string
	name: string
	email: string
	language: string
	profileColor: string
	profileImageUrl: string
	useYn: number
	deletedAt: string
	updatedAt: string
	updatedBy: string
	createdAt: string
	createdBy: string
	accessToken: string
	refreshToken: string
}

export { User }
